import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { canAccessPath, isStaffSession } from "../utils/permissions";

const Sidebar = ({ isCollapsed, isMobile, setIsCollapsed }) => {
  const [openDropdown, setOpenDropdown] = useState(null);

  const navigate = useNavigate();

  const toggleDropdown = (name) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };

  const handleLinkClick = () => {
    if (isMobile && typeof setIsCollapsed === "function") setIsCollapsed(true);
    setOpenDropdown(null);
  };

  const handleLogout = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || "https://api.editezy.com";
      await axios.post(
        `${apiUrl}/api/admin/logout`,
        {},
        { withCredentials: true },
      );
      localStorage.removeItem("authToken");
      localStorage.removeItem("token");
      localStorage.removeItem("staffId");
      localStorage.removeItem("staffName");
      localStorage.removeItem("staffEmail");
      localStorage.removeItem("staffPhone");
      localStorage.removeItem("staffIsActive");
      localStorage.removeItem("staffToken");
      localStorage.removeItem("staffPermissions");
      alert("Logout successful");
      window.location.href = "/";
    } catch (error) {
      console.error("Logout error:", error);
      alert("Logout failed. Please try again.");
    }
  };

  const showText = !isCollapsed;

  const elements = [
    {
      icon: <i className="ri-dashboard-fill text-white" />,
      name: "Admin Panel",
      path: "/dashboard",
    },
    {
      icon: <i className="ri-user-fill text-white" />,
      name: "Users",
      path: "/users",
      dropdown: [
        { name: "User List", path: "/users" },
        { name: "User ContactedList", path: "/usercontactedlist" },
        { name: "User Redemtion List", path: "/redemptions" },
      ],
    },
    {
      icon: <i className="ri-flag-fill text-white" />,
      name: "Reports",
      path: "/reported-users",
      dropdown: [{ name: "Reported Users", path: "/reported-users" }],
    },

    {
      icon: <i className="ri-group-fill text-white" />,
      name: "Staff Management",
      path: "/staff",
      dropdown: [
        { name: "Staff List", path: "/staff" },
        { name: "Create Staff", path: "/staff/create" },
      ],
    },

    {
      icon: <i className="ri-image-fill text-white" />,
      name: "Categories",
      path: "/categorylist",
      dropdown: [{ name: "Get All Categories", path: "/categorylist" }],
    },
    {
      icon: <i className="ri-image-fill text-white" />,
      name: "Posters",
      path: "/posterlist",
      dropdown: [
        { name: "Create Poster", path: "/create-poster" },
        { name: "Get All Posters", path: "/posterlist" },
      ],
    },
    {
      icon: <i className="ri-image-fill text-white" />,
      name: "Trending Posters",
      path: "/create-trending-posters",
      dropdown: [
        { name: "Category", path: "/create-trending-category" },
        { name: "create Posters", path: "/create-trending-posters" },
        { name: "Trending Posters", path: "/trending-posters" },
      ],
    },
    {
      icon: <i className="ri-video-fill text-white" />,
      name: "Reels",
      path: "/reels",
      dropdown: [
        { name: "Reel category", path: "/manage-reel-categories" },
        { name: "Pending Reels", path: "/pending-reels" },
        { name: "Manage Reels", path: "/reels" },
      ],
    },
    {
      icon: <i className="ri-music-fill text-white" />,
      name: "Audio",
      path: "/audio",
      dropdown: [{ name: "Manage Audio", path: "/audio" }],
    },
    {
      icon: <i className="ri-palette-fill text-white" />,
      name: "Logos",
      path: "/logolist",
      dropdown: [
        { name: "Logo Category", path: "/create-logocategory" },
        { name: "Create Logo", path: "/create-logo" },
        { name: "Get All Logos", path: "/logolist" },
      ],
    },
    {
      icon: <i className="ri-palette-fill text-white" />,
      name: "Business Cards",
      path: "/businesscardlist",
      dropdown: [
        { name: "Business Cards", path: "/business" },
        { name: "Business CardsList", path: "/businesscardlist" },
      ],
    },
    {
      icon: <i className="ri-shopping-bag-fill text-white text-lg"></i>,
      name: "Stickers",
      path: "/create-sticker",
      dropdown: [
        { name: "Sticker Category", path: "/stickers-category" },
        { name: "All Stickers", path: "/create-sticker" },
        // { name: "Get All Stickers", path: "/create-sticker" },
      ],
    },
    // {
    //   icon: <i className="ri-gift-fill text-white" />,
    //   name: "Celebration",
    //   path: "/celebration",
    //   dropdown: [{ name: "Celebration", path: "/celebration" }],
    // },
    {
      icon: <i className="ri-gallery-fill text-white" />,
      name: "Banners",
      path: "/banner",
      dropdown: [{ name: "Banner", path: "/banner" }],
    },
    {
      icon: <i className="ri-file-list-fill text-white" />,
      name: "Subscription Plans",
      path: "/planlist",
      dropdown: [
        { name: "Create Plan", path: "/create-plan" },
        { name: "Get All Plans", path: "/planlist" },
        { name: "Purchased Plans", path: "/userplanlist" },
        { name: "User Payments", path: "/paymentlist" },
      ],
    },
    {
      icon: <i className="ri-file-list-fill text-white" />,
      name: "User Plan Assignment",
      path: "/manuplanlist",
    },

    {
      icon: <i className="ri-wallet-fill text-white" />,
      name: "Set User Wallet",
      path: "/userwallet",
    },
    {
      icon: <i className="ri-money-rupee-circle-fill text-white" />,
      name: "Amount Config",
      path: "/amount-config",
    },
    {
      icon: <i className="ri-settings-3-fill text-white" />,
      name: "Settings",
      path: "/profile",
      dropdown: [
        { name: "Create Privacy & Policy", path: "/create-privacy" },
        { name: "Get Privacy & Policy", path: "/get-policy" },
        { name: "Create AboutUs", path: "/aboutus" },
        { name: "Get AboutUs", path: "/getaboutus" },
        { name: "Create ContactUs", path: "/contactus" },
        { name: "Get ContactUs", path: "/getcontactus" },
        { name: "Profile", path: "/profile" },
      ],
    },
    {
      icon: <i className="ri-logout-box-fill text-white" />,
      name: "Logout",
      action: handleLogout,
    },
  ];

  const visibleElements = elements
    .map((item) => ({
      ...item,
      dropdown: item.dropdown?.filter((subItem) => canAccessPath(subItem.path)),
    }))
    .filter((item) => {
      if (item.name === "Logout") return true;
      if (!isStaffSession()) return true;
      return item.dropdown?.length > 0 || (item.path && canAccessPath(item.path));
    });

  // Mobile: fixed overlay sidebar, slides in/out
  // Desktop: inline, icon-only when collapsed
  const sidebarStyle = isMobile
    ? {
        position: "fixed",
        top: 0,
        left: 0,
        height: "100%",
        width: "256px",
        zIndex: 30,
        transform: isCollapsed ? "translateX(-100%)" : "translateX(0)",
        transition: "transform 0.3s ease-in-out",
      }
    : {
        position: "relative",
        width: isCollapsed ? "64px" : "256px",
        transition: "width 0.3s ease-in-out",
        flexShrink: 0,
      };

  return (
    <div
      style={{
        ...sidebarStyle,
        background:
          "linear-gradient(135deg, rgba(31,41,55,0.97), rgba(59,130,246,0.9))",
        backdropFilter: "blur(12px)",
        borderRight: "1px solid rgba(255,255,255,0.15)",
        boxShadow: "4px 0 24px rgba(0,0,0,0.3)",
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        overflowX: "hidden",
        minHeight: "100vh",
      }}
      className="no-scrollbar"
    >
      {/* Header */}
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          display: "flex",
          alignItems: "center",
          justifyContent: showText ? "space-between" : "center",
          padding: "14px 12px",
          background: "rgba(255,255,255,0.08)",
          backdropFilter: "blur(12px)",
          borderBottom: "1px solid rgba(255,255,255,0.15)",
          minHeight: "56px",
        }}
      >
        {showText && (
          <span
            style={{
              color: "#fff",
              fontWeight: 700,
              fontSize: "15px",
              letterSpacing: "0.08em",
              whiteSpace: "nowrap",
            }}
          >
            Admin Panel
          </span>
        )}
        {/* Close button on mobile */}
        {isMobile && showText && (
          <button
            onClick={() =>
              typeof setIsCollapsed === "function" && setIsCollapsed(true)
            }
            style={{
              color: "rgba(255,255,255,0.8)",
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: "4px",
              lineHeight: 1,
            }}
          >
            <i className="ri-close-line" style={{ fontSize: "20px" }} />
          </button>
        )}
        {/* Icon placeholder when desktop collapsed */}
        {!isMobile && !showText && (
          <i
            className="ri-layout-left-fill"
            style={{ color: "rgba(255,255,255,0.5)", fontSize: "20px" }}
          />
        )}
      </div>

      {/* Nav */}
      <nav
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "2px",
          padding: showText ? "12px 10px 24px" : "12px 4px 24px",
        }}
      >
        {visibleElements.map((item, idx) => (
          <div key={idx}>
            {item.dropdown ? (
              <>
                <div
                  onClick={() => {
                    toggleDropdown(item.name);

                    if (item.path) {
                      navigate(item.path);
                    }
                  }}
                  title={!showText ? item.name : undefined}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "10px",
                    borderRadius: "10px",
                    cursor: "pointer",
                    color: "#fff",
                    fontWeight: 500,
                    fontSize: "13px",
                    transition: "background 0.2s",
                    gap: "10px",
                    justifyContent: showText ? "flex-start" : "center",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background =
                      "rgba(255,255,255,0.15)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "transparent")
                  }
                >
                  <span style={{ fontSize: "17px", flexShrink: 0 }}>
                    {item.icon}
                  </span>
                  {showText && (
                    <>
                      <span
                        style={{
                          flex: 1,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.name}
                      </span>
                      <FaChevronDown
                        style={{
                          fontSize: "10px",
                          flexShrink: 0,
                          transform:
                            openDropdown === item.name
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                          transition: "transform 0.3s",
                        }}
                      />
                    </>
                  )}
                </div>

                {showText && (
                  <div
                    style={{
                      overflow: "hidden",
                      maxHeight: openDropdown === item.name ? "500px" : "0",
                      opacity: openDropdown === item.name ? 1 : 0,
                      transition: "max-height 0.3s ease, opacity 0.3s ease",
                    }}
                  >
                    <ul
                      style={{
                        margin: "2px 0 2px 28px",
                        padding: 0,
                        listStyle: "none",
                        display: "flex",
                        flexDirection: "column",
                        gap: "1px",
                      }}
                    >
                      {item.dropdown.map((subItem, subIdx) => (
                        <li key={subIdx}>
                          <Link
                            to={subItem.path}
                            onClick={handleLinkClick}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              padding: "8px 8px",
                              borderRadius: "8px",
                              color: "rgba(255,255,255,0.75)",
                              fontSize: "13px",
                              textDecoration: "none",
                              transition: "all 0.2s",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background =
                                "rgba(255,255,255,0.15)";
                              e.currentTarget.style.color = "#fff";
                              e.currentTarget.style.paddingLeft = "12px";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = "transparent";
                              e.currentTarget.style.color =
                                "rgba(255,255,255,0.75)";
                              e.currentTarget.style.paddingLeft = "8px";
                            }}
                          >
                            <span style={{ opacity: 0.5, fontSize: "10px" }}>
                              ✦
                            </span>
                            {subItem.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </>
            ) : (
              <Link
                to={item.path || "#"}
                onClick={
                  item.action
                    ? (e) => {
                        e.preventDefault();
                        item.action();
                      }
                    : handleLinkClick
                }
                title={!showText ? item.name : undefined}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "10px",
                  borderRadius: "10px",
                  color: "#fff",
                  fontWeight: 500,
                  fontSize: "13px",
                  textDecoration: "none",
                  gap: "10px",
                  justifyContent: showText ? "flex-start" : "center",
                  transition: "background 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.background = "rgba(255,255,255,0.15)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.background = "transparent")
                }
              >
                <span style={{ fontSize: "17px", flexShrink: 0 }}>
                  {item.icon}
                </span>
                {showText && (
                  <span
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {item.name}
                  </span>
                )}
              </Link>
            )}
          </div>
        ))}
      </nav>

      <style>{`
        .no-scrollbar::-webkit-scrollbar { width: 3px; }
        .no-scrollbar::-webkit-scrollbar-track { background: rgba(255,255,255,0.05); border-radius: 10px; }
        .no-scrollbar::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.25); border-radius: 10px; }
      `}</style>
    </div>
  );
};

export default Sidebar;
